import {inject, Injectable} from '@angular/core';
import {FilesService} from "../../../../services/files.service";
import {FilesStatus, GetFilesStatusParams} from "../../../../types/files-status.types";
import {
  advertisementStatisticsResourceType,
  defaultAdvertisementStatisticsFilesStatus
} from "../configs/advertisement-statistics-modal-config";
import {GetSelectDataParams, RecordData, SelectData} from "../../../../types/records-table.types";
import {RecordTableApiService} from "../../../../services-api/record-table-api.service";

@Injectable({
  providedIn: 'root'
})
export class AdvertisementStatisticsModalService {
  private filesService: FilesService = inject(FilesService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public async fetchFilesStatus(id: number): Promise<FilesStatus> {
    const getFilesStatusParams: GetFilesStatusParams = {
      id: id,
      path: advertisementStatisticsResourceType.path
    };

    return await this.filesService.fetchFilesStatus(getFilesStatusParams).catch(() => defaultAdvertisementStatisticsFilesStatus);
  }

  public setAdvertisementStatisticsData(advertisementStatisticsData: RecordData, key: string) {
    return {
      path: advertisementStatisticsResourceType.path,
      modalName: `Текст Комментарий оценщика`,
      recordId: advertisementStatisticsData.id,
      key: key,
      fieldLabel: 'Комментарий оценщика',
      content: advertisementStatisticsData[key]
    };
  }

  public fetchSelectData(getSelectDataParams: GetSelectDataParams): Promise<Array<SelectData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }
}
